import type { FC } from 'react';
import { useParams } from 'react-router-dom';
import useRevenueAccounting from './hooks/useRevenueAccounting';
import useRevenueSocket from './hooks/useRevenueSocket';
import {
  ErrorState,
  LoadingSkeleton,
  MissingOrderState,
  NoRevenueDataYetState,
} from './components/RevenueStates';
import RevenueView from './components/RevenueView';

const RevenueContainer: FC = () => {
  const { id: orderId } = useParams<{ id: string }>();

  useRevenueSocket();

  const {
    isLoading,
    isError,
    hasOrder,
    revenueEntries,
    grouped,
    kpis,
    debtEquityContext,
    refetch,
  } = useRevenueAccounting(orderId || '');

  if (!orderId) {
    return <MissingOrderState />;
  }

  if (isLoading) {
    return <LoadingSkeleton />;
  }

  if (isError) {
    return <ErrorState onRetry={refetch} />;
  }

  if (!hasOrder) {
    return <MissingOrderState />;
  }

  if (revenueEntries.length === 0) {
    return <NoRevenueDataYetState />;
  }

  return (
    <RevenueView
      grouped={grouped}
      kpis={kpis}
      debtEquityContext={debtEquityContext}
      revenueEntries={revenueEntries}
    />
  );
};

export default RevenueContainer;
